import React from 'react';
import Tooltip from '@roo/roo/Tooltip';
import pageJump from '@projects/Shell/utils/pageJump';
import { IKangarooInfo, KangarooStatus } from '../../../../api/define';
import styles from './PoliList.module.scss';
import KangarooLog from './KangarooLogo';

const { useMemo } = React;

type KangarooInfoProps = {
    /** 袋鼠店长信息 */
    info: IKangarooInfo;
};

const renderKangarooTips = (status: number, url: string, name: string | null) => {
    //袋鼠店长tips状态显示
    if (status === KangarooStatus.EXPIRE) {
        return (
            <div>
                您的袋鼠店长已过期，
                <span
                    className={styles.link}
                    onClick={() => {
                        //跳转IM设置页
                        pageJump.go(url);
                    }}
                >
                    去续费
                </span>
            </div>
        );
    }
    return `袋鼠店长${name ? ` - ${name}` : ''}`;
};

const KangarooTip: React.FC<KangarooInfoProps> = ({ info }) => {
    //袋鼠店长状态显示
    const displayKangaroo = useMemo(() => {
        const { status, version } = info;
        return (
            <Tooltip
                placement="bottom"
                content={renderKangarooTips(info.status, info.url, info.name)}
                effect="dark"
                trigger="hover"
            >
                <div
                    className={styles.kangarooImg}
                    onClick={() =>
                        pageJump.go(`${window.CommConstants.eappBaseUrl}/ad/v1/rpc#/manager`)
                    }
                >
                    <KangarooLog status={status} version={version} />
                </div>
            </Tooltip>
        );
    }, [info.name, info.status, info.version]);

    return <div className={styles.kangarooInfo}>{displayKangaroo}</div>;
};

export default KangarooTip;
